<template>
  <div class="config page">
    <AppHeader :back_button="showBackButton">{{$root.texts.section_settings.title}}</AppHeader>
    <div class="config__content">
      <div class="config__desc">{{$root.texts.section_settings.title_languages}}</div>
      <button
        v-for="(language, key, i) in $root.texts.languages"
        :class="{'btn':true, 'btn-selected':(i==$root.language_selected) }"
        :key="'language_'+i"
        @click="changeLanguage(i)"
      >{{language}}</button>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";

export default {
  name: "config",
  props: {
    showBackButton: Boolean,
    nextPage: String
  },
  methods: {
    changeLanguage: function(n) {
      this.$root.language_selected = n;
      this.$root.changeLanguage(n);
      if (this.nextPage) {
        this.$router.push({ name: this.nextPage });
      } else {
        this.$router.back();
      }
    }
  },
  components: {
    AppHeader
  }
};
</script>
